// extracted by mini-css-extract-plugin
export var cancelButton = "_pf-5";
export var content = "_pf-3";
export var createButton = "_pf-6";
export var drawerContainer = "_pf-0";
export var footer = "_pf-2";
export var header = "_pf-1";
export var orderFormColumn = "_pf-4";